var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 71,
    fill: "url(#pattern0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.41357,
    y1: 3.30933,
    x2: 3.41357,
    y2: 8.12289,
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.41357,
    y1: 2.61017,
    x2: 7.24116,
    y2: 2.61017,
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 4.81356,
    y2: -1,
    transform: "matrix(1.45294e-07 1 1 -1.31504e-08 67.8877 3.30933)",
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 4.82759,
    y2: -1,
    transform: "matrix(-1 0 0 1 67.8877 3.61017)",
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 4.81356,
    y2: -1,
    transform: "matrix(-1.45294e-07 -1 -1 1.31504e-08 2.41357 67.3898)",
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 4.82759,
    y2: -1,
    transform: "matrix(1 0 0 -1 2.41357 67.089)",
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 66.8877,
    y1: 67.3898,
    x2: 66.8877,
    y2: 62.5763,
    stroke: "#DD0071",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 67.8877,
    y1: 68.089,
    x2: 63.0601,
    y2: 68.089,
    stroke: "#DD0071",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4806_162991",
    transform: "matrix(0.015625 0 0 0.0154049 0 -0.000660211)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4806_162991",
    width: 64,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABBCAYAAABhNaJ7AAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAECgAwAEAAAAAQAAAEEAAAAAiAsGAwAAAAlwSFlzAAALEwAACxMBAJqcGAAACJ5JREFUeAHlmk1WVDsQx2/zHDhTVwCuQHcgrgBdgbgCYQXCCoQVICtQh46AFQgzZuBMR09mznj1y/Pfp2516t402J4jXeeEJJX6SlXl46aZdL/g+vp63ZqUZYDjyWRyzEQn/LHJH1i1SXuJYM+csH3PJv/WJr25RBPXVLds7lcT+3NhmDVhl6y+xAHXSzbp3nRXer0l7NzL5ry7u5sNDeKfPXvWra+vT2kuLy+7w8PDbm1trXv16tUUT6NVx8bGRvf06dPu+Pi4Ozk56clo7bx9y1ZXAZZADYyUpTF32dnZ6Yk7OjoqMswpPTydVvnv378vvMhu5Yl0M8p/IdIMMAEFtra2uocPH6qb1kSHEoHIm+EFnUVc43t7e92PHz+iiJk+GeazbIbgFwJZyByEzDPGVLx9cXGRkfTwig51DZQJkutr0ZuzqhGOGZDpkBzV2C49wsV6NANMQIGPHz9Wo0MkiHIE1r7PiK9fvxYSsunFixelbROLbKXPuM+61dXVKl3UISKvQ7isbnbA9vZ2h8IITKLmACb/+vXrSF4mdnBwUPCZA968edOU4pkO7JGTZwwIiGYHBL7RLlEgO1iHp6enPXplBuM1ODs7K2h2fp8JNdrb4hbmACJAYbLPnz+f2kkWqW/rcYr3DTZewPaNpkzwvPO2F+YAGVLLhBh5ZUTLCSC5v6teuANIYyKpTGB90vegjPC4P9VudkBto8PIBw8eDNpKVBVZZGRyakI4OVgyZFFtLwBXk1fD1eSDa3ZAjFomMOLZAIkwaW/nchwe7G9ubpZxTot4jWZA+0whuuGflRvy3R22eDNS32bIFj130S3NzvrCa5EvIi2DSt/SUyqmsoVgDJ3QAvDStwwofd02b2JXEVD5s/QZkO4B5ixz9O2B3d/e3gYFaZw9wrIgpeWTNv2sTbmGB5Y+A7rKsigo1mOtfPnypYzbba06Lh47osr6ZR3zVaY9weIx5aPtC3QetAcgS3Kp7RPXk03b7B2Ma9+ZDgw00iVQ+/AhmXSmU2c00HkwozqKoJVP9P4uAU42aNzX88pOHcB6BDjDEWreLZPgC49iO/Lgevz06VOnO7030LelQzjvJOHmqS3yvbsGduuWGXVJbuqAaAx94eRl9SXM12M3RGiH+L2sedpRpmzNZKTP4vIcNzCE8rCJMG52pODYpyo88MKTPYoSMQ9kFvTv3r0r8qVLNNwIJctPFDmcDtDzbiHATnCAbQNC9+tsf4CHYqlTSExhb8PSeFbbNbbwsTFB07IxSYcuQtG27CIUddVsirLUT5eAXm30kJmdv0SEs557Oc/XAj5kiKhNqkNW7WNGtNAB2tzQiVx0wk/keQ5XNKULvdAJyEp0IYdMQCfZNAjyRFabAb1MiHR43xRcEx0POvZaIg9/rSgTpEM00iUdygDpJ2uhxfYxSDPABBTAg3g0RlBRIQoAj6asX4FvC0et6Hic2jxh+82T6CrDRONr1j4RV7aRAbwnCtCl7IKuCmMeysZjVEx4NYoxAxSdGr32G+mEt0anDBCdMkG6ajpEG+s0A7T25TU8G7NAY9SmvBQygkI0WKus4TGwCRWSIfljMvw4cpBJBtz6hxETXKIQoxMzQFGhhieuS3l+nugQUen3tXRJZswA4b0u4WL9jwnbMeEzwLoiiqzlnz9/do8fP+7Oz8/LTsxuzBcc0cXLFLwO3dXVVcEzBi+0FGjAAd+/fy+ykU9hDBrG79+/X2j4w/pHhrIL3Ldv36a6JJMae7BBsqT38+fPsHXJNC1UI2BGVaNgm2DhzDJBUTHdhZ9oZiCamGXKAOmySfRsiVmmO4fk+TrTne4B7PIA3gf00xjrGk8TGWiImhlSaPQHPPuAB9F7XNaWLnQjXz+NPXnypKeLMdkgWmwhC5CBndg7CJlnjKl4W1ExZaUfz2YzoCciRklyWmrpssn0dPUUuI6yzCbtsPY/P7/jHqDIEzkKXgX0sxVtaBQd0VF7IAqs8yGI2SJ69qE45uWwzgFsg87rwjYyZBR6rqt0FHkT1Ft/rZE3QypS+yjJVgZoFF6NtdQtuiRbdboHmMICmRf9jQ1CvO9piYpKzArRCa/+/xpn/yKbEkHyI56+ZGss1SFP/O5a69MM6EXRDJmq0tgUERrKgJhtIos6lAHaAySfOoM0A6IHTUgTZNGqMSsqrboU8Xl01PR6XOoALj43AS4c2adzlGeRKig9i8fx2N/f3++QP4+OKCP2VyJi2fqjDiBKtn5GC1Gpga3LHq+iXqMVzu4ahQdeD2QWtoxlGEsLuhZdow7wBtzFdrMD2BNYq7H4J6lFOYjrbdRLX48dmV5lAtmQQbMDMgF/Oz49BW47MT5C/BrmqppFLK5V6CgcewDPcv6jhkcOToQI6CBTiTz7SAsszAG1szo77zE4gqd99OhRmZRo6Gfg+TIaj1+YA3jG9ieDooljPnz4UGzQjy+q7WbXmyiR5hNYH0cynB9c+K906SDT/MmADgCdL1++LO0sIxbmANKalIyAcX5pMF6jA8/kIy14MoaiaNOu0eGATDZygGYHEJ0axOjUaMBBx1pWdGp02iP0masfN3iQZQ/gxLHvgvIo4v9pikmSRdLREnnpb3ZAzcMS0lLXIh/5YrTkCI5BgIhDE20BTxEo8llmiI561AGKgmeqtWVsHCMqRFA/XuAI/VylrFLkxct6xnie5v3ENK4fYaCRDMZiduEIyfZ0klNquyRUwQa5PcxdbOMr8kxh4bVolT5Pacgzo2f0RT3QAvAyps9hZHva+BRWmOyP7T89OngySDPA7+AmoBnYnQEijwyiBFDTj1FiDLwH8bDOSXc2QwDZnlZ4z0sbHZ4ujvt++v8Bnugut5f+KowDLu9yhEfmdooDZi/VI1x3aHhvxT4r92xCu3doUq1T2bW5H05EbcfEmrU3rORfGiL+u+t/zfwzm/wx0/gPLK8ozzPUuoUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrDownload);
export default __webpack_public_path__ + "static/media/qr_download.906846d409a1b734c6693da33cad4251.svg";
export { ForwardRef as ReactComponent };